import Hero from "../components/Hero";
import HeroImage from "../../assets/images/LandlordInsurance1.jpg";
import landlordInsurancePageImage from "../../assets/images/LandlordInsurance2.jpg";
import Accordion from "../designSystem/Accordion";

const LandlordInsurancePage = () => {
  return (
    <div className="home-page">
      <Hero
        title="Landlord Insurance"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <section className="grey-container">
        <div className="grey-container-content">
          <div className="row">
            <div className="content-column">
              <h2 className="burgandy align-left">Why is it Important?</h2>
              <div className="divider burgandy align-left" />
              <div className="content grey align-left">
                Standard home insurance isn’t designed for rental properties.
                Landlord insurance provides specialist cover to protect your
                property, rental income, and responsibilities as a landlord.
              </div>
            </div>
            <img
              src={landlordInsurancePageImage}
              alt="WPP Financial Services Building"
              className="image-container"
            />
          </div>
        </div>
      </section>
      <section className="white-container">
        <div className="white-container-content">
          <div className="column">
            <h2 className="burgandy">Key Information</h2>
            <div className="divider burgandy" />
            <Accordion title="What Does It Cover?">
              <ul>
                <li>Landlord insurance typically includes:</li>
                <li>
                  Buildings Cover – Protection for the structure against risks
                  like fire, flood, storms, and theft
                </li>
                <li>
                  Contents Cover (optional) – Covers furnishings such as
                  carpets, furniture, and appliances
                </li>
                <li>
                  Malicious Damage – Protection against deliberate damage
                  (including by tenants, depending on policy)
                </li>
                <li>
                  Loss of Rent – Covers lost income if the property becomes
                  uninhabitable
                </li>
                <li>
                  Landlord Liability – Covers legal costs for injury or damage
                  claims on your property
                </li>
              </ul>
            </Accordion>
            <Accordion title="Key Features to Look For">
              <ul>
                <li>Alternative accommodation for tenants</li>
                <li>Trace and access (e.g. locating leaks)</li>
                <li>Cover for stolen keys or damaged locks</li>
                <li>
                  Flexible cover levels based on furnished or unfurnished
                  properties
                </li>
              </ul>
            </Accordion>
            <Accordion title="Optional Extras">
              <ul>
                <li>
                  Accidental Damage Cover – Protection against everyday mishaps
                </li>
                <li>
                  Legal Expenses – Help with disputes, evictions, or legal costs
                </li>
                <li>Rent Guarantee – Covers missed rental payments</li>
                <li>
                  Landlord Emergency Cover – 24/7 support for urgent repairs
                </li>
              </ul>
            </Accordion>
            <Accordion title="Important Considerations">
              <ul>
                <li>Tenants need their own contents insurance</li>
                <li>
                  Policies may not cover routine maintenance, pets, or long
                  unoccupied periods
                </li>
                <li>
                  Higher excess can reduce premiums but increases claim costs
                </li>
                <li>
                  Ensure cover is in the correct name (individual or company)
                </li>
              </ul>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandlordInsurancePage;
